import '../css/app.css';
import './bootstrap.js';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance from '@bugsnag/browser-performance';

const app = createApp(App);

if (import.meta.env.MODE === 'production') {
    Bugsnag.start({
        apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
        appVersion: import.meta.env.VITE_BUGSNAG_APP_VERSION,
        plugins: [new BugsnagPluginVue()],
    });

    BugsnagPerformance.start({
        apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
        appVersion: import.meta.env.VITE_BUGSNAG_APP_VERSION,
    });
    const bugsnagVue = Bugsnag.getPlugin('vue');
    if (bugsnagVue) {
        app.use(bugsnagVue);
    }
} else {
    window.currentCollege = 'owensboro';
}

app.directive('click-outside', {
        beforeMount(el, binding) {
            /** @type {HTMLElement & { clickOutsideEvent?: (event: MouseEvent) => void }} */
            let target = el;
            target.clickOutsideEvent = function (event) {
                let previous = target.previousElementSibling;
                if (
                    !(
                        target === event.target ||
                        (event.target instanceof Node && target.contains(event.target)) ||
                        previous === event.target ||
                        (previous instanceof Node && event.target instanceof Node && previous.contains(event.target))
                    )
                ) {
                    binding.value(event, target);
                }
            };
            document.body.addEventListener('click', target.clickOutsideEvent);
        },
        unmounted(el) {
            /** @type {HTMLElement & { clickOutsideEvent?: (event: MouseEvent) => void }} */
            let target = el;
            if (target.clickOutsideEvent) {
                document.body.removeEventListener('click', target.clickOutsideEvent);
            }
        },
    })
    .use(createPinia())
    .mount('#class-search');
